import { API, authClient } from "../index";

// Get all paises
export const getPaises = () => {
  return authClient().get(`${API}/pais?getDisabled=true`);
};

// Get pais by id
export const getPaisById = (id) => {
  return authClient().get(`${API}/pais/${id}`);
};

// Delete pais
export const deletePais = (id) => {
  return authClient().delete(`${API}/pais/${id}`);
};

// Create pais
export const postPais = async (pais) => {
  return authClient().post(`${API}/pais`, pais);
};

// Update pais
export const updatePais = async (id, pais) => {
  return authClient().put(`${API}/pais/${id}`, pais);
};

// Change status pais
export const changeStatusPais = async (id, active) => {
  return authClient().put(`${API}/pais/change-status/${id}`, { active });
};
